/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaButton/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function TysiaButton({
  children,
  viewPath = "/DesignSystem/TysiaButton",
  alignSelf = "flex-start",
  onClick,
  height,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  borderBottomLeftRadius,
  borderBottomRightRadius,
  borderTopLeftRadius,
  borderTopRightRadius,
  boxshadow,
  disabled,
  onMouseEnter,
  onMouseLeave,
  title,
  innerRef,
  size = "normal",
  type = "primary",
  hovered,
  selected,
  isSelected
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({onMouseEnter,onMouseLeave})
let dtTysiabuttonBackgroundcolorPrimaryActive = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButton.backgroundColor.primary.active'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtTysiabuttonBordercolorPrimaryActive = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButton.borderColor.primary.active'
        })
let dtTysiabuttonBackgroundcolorPrimaryHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButton.backgroundColor.primary.hovered'
        })
let dtTysiabuttonBordercolorPrimaryHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButton.borderColor.primary.hovered'
        })
let dtTysiabuttonBackgroundcolorPrimarySelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButton.backgroundColor.primary.selected'
        })
let dtTysiabuttonBordercolorPrimarySelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButton.borderColor.primary.selected'
        })
let dtTysiabuttonBackgroundcolorPrimaryDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButton.backgroundColor.primary.disabled'
        })
let dtTysiabuttonBordercolorPrimaryDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButton.borderColor.primary.disabled'
        })
let dtTysiabuttonBackgroundcolorSecondaryHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButton.backgroundColor.secondary.hovered'
        })
let dtTysiabuttonBordercolorSecondaryHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButton.borderColor.secondary.hovered'
        })
let dtTysiabuttonBackgroundcolorSecondarySelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButton.backgroundColor.secondary.selected'
        })
let dtTysiabuttonBordercolorSecondarySelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButton.borderColor.secondary.selected'
        })
let dtTysiabuttonBackgroundcolorSecondaryDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButton.backgroundColor.secondary.disabled'
        })
let dtTysiabuttonBordercolorSecondaryDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButton.borderColor.secondary.disabled'
        })
let dtTysiabuttonBackgroundcolorSecondaryActive = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButton.backgroundColor.secondary.active'
        })
let dtTysiabuttonBordercolorSecondaryActive = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButton.borderColor.secondary.active'
        })
let dtTysiabuttonBackgroundcolorCriticalHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButton.backgroundColor.critical.hovered'
        })
let dtTysiabuttonBordercolorCriticalHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButton.borderColor.critical.hovered'
        })
let dtTysiabuttonBackgroundcolorCriticalSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButton.backgroundColor.critical.selected'
        })
let dtTysiabuttonBordercolorCriticalSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButton.borderColor.critical.selected'
        })
let dtTysiabuttonBackgroundcolorCriticalDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButton.backgroundColor.critical.disabled'
        })
let dtTysiabuttonBordercolorCriticalDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButton.borderColor.critical.disabled'
        })
let dtTysiabuttonBackgroundcolorCriticalActive = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButton.backgroundColor.critical.active'
        })
let dtTysiabuttonBordercolorCriticalActive = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButton.borderColor.critical.active'
        })
let dtTysiabuttonBackgroundcolorGhostHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButton.backgroundColor.ghost.hovered'
        })
let dtTysiabuttonBordercolorGhostHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButton.borderColor.ghost.hovered'
        })
let dtTysiabuttonBackgroundcolorGhostSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButton.backgroundColor.ghost.selected'
        })
let dtTysiabuttonBordercolorGhostSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButton.borderColor.ghost.selected'
        })
let dtTysiabuttonBackgroundcolorGhostDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButton.backgroundColor.ghost.disabled'
        })
let dtTysiabuttonBordercolorGhostDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButton.borderColor.ghost.disabled'
        })
let dtTysiabuttonBackgroundcolorGhostActive = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButton.backgroundColor.ghost.active'
        })
let dtTysiabuttonBordercolorGhostActive = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButton.borderColor.ghost.active'
        })
let borderBottomLeftRadiusOrdtSpaceXxs = borderBottomLeftRadius ?? dtSpaceXxs
let borderBottomRightRadiusOrdtSpaceXxs = borderBottomRightRadius ?? dtSpaceXxs
let borderTopLeftRadiusOrdtSpaceXxs = borderTopLeftRadius ?? dtSpaceXxs
let borderTopRightRadiusOrdtSpaceXxs = borderTopRightRadius ?? dtSpaceXxs
  return (<React.Fragment
>
<button
  data-testid="TysiaButton.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 boxshadow={boxshadow}
 disabled={disabled}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 title={title}
 ref={innerRef}
 style={{'--as-1-cyg2o': alignSelf,'--h-2-cyg2o': typeof height === 'number' ? `${height}px` : height,'--mb-4-cyg2o': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-5-cyg2o': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-6-cyg2o': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-7-cyg2o': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--bblr-11-cyg2o': typeof borderBottomLeftRadiusOrdtSpaceXxs === 'number' ? `${borderBottomLeftRadiusOrdtSpaceXxs}px` : borderBottomLeftRadiusOrdtSpaceXxs,'--bbrr-12-cyg2o': typeof borderBottomRightRadiusOrdtSpaceXxs === 'number' ? `${borderBottomRightRadiusOrdtSpaceXxs}px` : borderBottomRightRadiusOrdtSpaceXxs,'--btlr-13-cyg2o': typeof borderTopLeftRadiusOrdtSpaceXxs === 'number' ? `${borderTopLeftRadiusOrdtSpaceXxs}px` : borderTopLeftRadiusOrdtSpaceXxs,'--btrr-14-cyg2o': typeof borderTopRightRadiusOrdtSpaceXxs === 'number' ? `${borderTopRightRadiusOrdtSpaceXxs}px` : borderTopRightRadiusOrdtSpaceXxs,'--pl-8-cyg2o': size === "normal" ? "7px" : size === "small" ? "5px" : "7px",'--pr-9-cyg2o': size === "normal" ? "7px" : size === "small" ? "5px" : "7px",'--bc-10-cyg2o': type === "primary" && hovered ? dtTysiabuttonBackgroundcolorPrimaryHovered : type === "primary" && selected ? dtTysiabuttonBackgroundcolorPrimarySelected : type === "primary" && disabled ? dtTysiabuttonBackgroundcolorPrimaryDisabled : type === "primary" ? dtTysiabuttonBackgroundcolorPrimaryActive : type === "secondary" && hovered ? dtTysiabuttonBackgroundcolorSecondaryHovered : type === "secondary" && selected ? dtTysiabuttonBackgroundcolorSecondarySelected : type === "secondary" && disabled ? dtTysiabuttonBackgroundcolorSecondaryDisabled : type === "secondary" ? dtTysiabuttonBackgroundcolorSecondaryActive : type === "critical" && hovered ? dtTysiabuttonBackgroundcolorCriticalHovered : type === "critical" && selected ? dtTysiabuttonBackgroundcolorCriticalSelected : type === "critical" && disabled ? dtTysiabuttonBackgroundcolorCriticalDisabled : type === "critical" ? dtTysiabuttonBackgroundcolorCriticalActive : type === "ghost" && hovered ? dtTysiabuttonBackgroundcolorGhostHovered : type === "ghost" && selected ? dtTysiabuttonBackgroundcolorGhostSelected : type === "ghost" && disabled ? dtTysiabuttonBackgroundcolorGhostDisabled : type === "ghost" ? dtTysiabuttonBackgroundcolorGhostActive : dtTysiabuttonBackgroundcolorPrimaryActive,'--bc-15-cyg2o': type === "primary" && hovered ? dtTysiabuttonBordercolorPrimaryHovered : type === "primary" && selected ? dtTysiabuttonBordercolorPrimarySelected : type === "primary" && disabled ? dtTysiabuttonBordercolorPrimaryDisabled : type === "primary" ? dtTysiabuttonBordercolorPrimaryActive : type === "secondary" && hovered ? dtTysiabuttonBordercolorSecondaryHovered : type === "secondary" && selected ? dtTysiabuttonBordercolorSecondarySelected : type === "secondary" && disabled ? dtTysiabuttonBordercolorSecondaryDisabled : type === "secondary" ? dtTysiabuttonBordercolorSecondaryActive : type === "critical" && hovered ? dtTysiabuttonBordercolorCriticalHovered : type === "critical" && selected ? dtTysiabuttonBordercolorCriticalSelected : type === "critical" && disabled ? dtTysiabuttonBordercolorCriticalDisabled : type === "critical" ? dtTysiabuttonBordercolorCriticalActive : type === "ghost" && hovered ? dtTysiabuttonBordercolorGhostHovered : type === "ghost" && selected ? dtTysiabuttonBordercolorGhostSelected : type === "ghost" && disabled ? dtTysiabuttonBordercolorGhostDisabled : type === "ghost" ? dtTysiabuttonBordercolorGhostActive : dtTysiabuttonBordercolorPrimaryActive,'--sox-16-cyg2o': type === "secondary" ? "0px" : type === "critical" ? "0px" : "0px",'--soy-17-cyg2o': type === "secondary" ? "1px" : type === "critical" ? "1px" : "0px",'--sb-18-cyg2o': type === "secondary" ? "2px" : type === "critical" ? "2px" : "0px",'--ss-19-cyg2o': type === "secondary" ? "0px" : type === "critical" ? "0px" : "0px",'--sc-20-cyg2o': type === "secondary" ? "rgba(31, 41, 51, 0.15)" : type === "critical" ? "rgba(31, 41, 51, 0.15)" : 0,'--c-3-cyg2o': disabled ? "default" : "pointer"}}
 className={`views-block ${styles.Horizontal}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 type={type}
 size={size}
 hovered={hovered}
 selected={selected}
 disabled={disabled}
 isSelected={isSelected} isHovered={isHovered} isSelectedHovered={isSelectedHovered}
>
{children}
</Children>
</button>
</React.Fragment>)
}